import {useEffect, useState} from "react";

import {useLoadingDispatcher} from "../../context/LoadingContext";
import {LoadingHelper} from "../../util/LoadingHelper";
import {ServerErrorHandler} from "../../service/errorHandler/ServerErrorHandler";

import {css} from "@emotion/css";
import {
    RaikoAlert,
    raikoAlertTypes,
    RaikoBaseCardContainer,
    RaikoGridOneColumn,
    RaikoSectionContainer,
    RaikoToggleOutlined,
    showErrorMessage,
    showSuccessMessage,
    showWarningMessage
} from "@moeindal/base-raiko-panel-components";

export const ManagerBanAccess = ({managerId, service}) => {

    const loadingDispatcher = useLoadingDispatcher()
    const loading = new LoadingHelper(loadingDispatcher)

    useEffect(() => {
        if (managerId && managerId >= 0) {
            getManagerEnabledStatus()
        }
    }, [])

    function getManagerEnabledStatus() {
        loading.show()
        service.getManagerEnabled(managerId)
            .then(response => {
                setBanState(response.enabled)
            }).catch(reason => {
            showErrorMessage(new ServerErrorHandler(reason).getMessage())
        }).finally(_ => {
            loading.hide()
        })
    }

    const [banState, setBanState] = useState(true);

    function changeManagerEnabledState(state) {
        loading.show()
        service.changeManagerEnabledState(managerId, state)
            .then(response => {
                setBanState(state)

                if (state)
                    showSuccessMessage("دسترسی مدیر به سامانه با موفقیت آزاد شد.")
                else
                    showWarningMessage("دسترسی مدیر به سامانه با موفقیت مسدود شد.")
            }).catch(reason => {
            showErrorMessage(new ServerErrorHandler(reason).getMessage())
        }).finally(_ => {
            loading.hide()
        })
    }

    return (
        <RaikoBaseCardContainer className={css`margin-top: 1rem;`}>
            <RaikoSectionContainer title={"مسدود سازی"}>
                <RaikoGridOneColumn>
                    <RaikoAlert
                        title={"لطفا نکات زیر را مورد توجه قرار دهید:"}
                        type={raikoAlertTypes.error}
                        description={[
                            "با مسدود سازی مدیر دسترسی مدیر به پنل بسته خواهد شد.",
                        ]}
                    />
                    <RaikoToggleOutlined
                        labelText={"مسدود سازی"}
                        setChecked={state => {
                            changeManagerEnabledState(!state)
                        }}
                        checked={!banState}
                    />
                </RaikoGridOneColumn>
            </RaikoSectionContainer>
        </RaikoBaseCardContainer>
    )
}